(() => {
  if (window.jdmBundleSafety) return;
  const script = document.currentScript;
  const current = { id: script.dataset.productId, vendor: script.dataset.productVendor, url: script.dataset.productUrl };
  const labels = { pending: script.dataset.pending, required: script.dataset.required, idoing: script.dataset.idoing, error: script.dataset.error, configure: script.dataset.configure };
  const state = window.jdmBundleSafety = { productId: current.id, gpoCompleted: false, required: false, status: 'pending' };
  const products = new Map([[current.id, { status: 'ready', product: current, href: current.url }]]);
  const buttonStates = new WeakMap();
  let frame = 0;
  let notice;
  const productRoot = () => document.querySelector('.product:has(.jdm-product-identity)');
  const bundleRoot = () => document.getElementById('frequently-bought-together-app-block');
  const schedule = () => { if (!frame) frame = requestAnimationFrame(() => { frame = 0; refresh(); }); };
  const isIdoing = (vendor) => String(vendor || '').trim().toLowerCase() === 'idoing';
  function requiredOptions() {
    const root = productRoot();
    const app = root?.querySelector('.gpo-app');
    const fields = app ? Array.from(app.querySelectorAll('[presence]')) : [];
    const hasRequired = fields.some((field) => !['false', '0'].includes(field.getAttribute('presence')));
    const metadata = app && String(window.GPOConfigs?.renderingProduct?.id) === current.id && window.GPOConfigs?.option?.flatElements;
    if (hasRequired || (Array.isArray(metadata) && metadata.some((field) => { const value = field.required ?? field.presence; return Boolean(value) && !['false', '0'].includes(String(value).toLowerCase()); }))) state.required = true;
    return state.required;
  }
  document.addEventListener('gpoRenderCompleted', (event) => {
    if (String(event.detail?.product?.id) !== current.id) return;
    const root = productRoot();
    if (!event.detail?.form || !root || !root.contains(event.detail.form)) return;
    state.gpoCompleted = true;
    requiredOptions();
    schedule();
  });
  function resolveProduct(id, href) {
    const cached = products.get(id);
    if (cached && (cached.status !== 'error' || cached.href === href)) return cached;
    const entry = { status: 'pending', href };
    products.set(id, entry);
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
      if (url.origin !== window.location.origin || !match) throw new Error('Unverified product link');
      const locale = window.Shopify?.routes?.root || '/';
      const endpoint = new URL(`${locale}products/${match[1]}.js`, window.location.origin);
      if (endpoint.origin !== window.location.origin) throw new Error('Invalid product origin');
      fetch(endpoint.href, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((response) => {
        if (!response.ok) throw new Error('Product lookup failed');
        return response.json();
      }).then((product) => {
        if (String(product.id) !== id || typeof product.vendor !== 'string') throw new Error('Product identity mismatch');
        entry.product = { id, vendor: product.vendor, url: url.pathname };
        entry.status = 'ready';
        schedule();
      }).catch(() => { entry.status = 'error'; schedule(); });
    } catch { entry.status = 'error'; }
    return entry;
  }
  function assess(root) {
    const main = productRoot();
    const actualId = main?.querySelector('[data-product-title-id]')?.dataset.productTitleId;
    if (actualId && actualId !== current.id) return { status: 'error', id: actualId, href: main.closest('product-info')?.dataset.url || window.location.href };
    const completion = window.jdmPurchaseBootstrap?.completed?.[current.id];
    if (completion?.form && main?.contains(completion.form)) state.gpoCompleted = true;
    if (requiredOptions()) return { status: 'required', href: current.url };
    const inputs = Array.from(root.querySelectorAll('.cbb-frequently-bought-selector-input[name^="product_"]'));
    if (!inputs.length) return { status: 'pending', href: current.url };
    let unresolved = false;
    let failed = false;
    for (const input of inputs) {
      const id = input.name.slice('product_'.length);
      const row = input.closest('li');
      const link = row?.querySelector('a.cbb-frequently-bought-selector-link[href]');
      const entry = resolveProduct(id, id === current.id ? current.url : link?.href);
      if (entry.status === 'ready' && isIdoing(entry.product.vendor)) return { status: 'idoing', href: entry.href || entry.product.url, id };
      unresolved ||= entry.status === 'pending';
      failed ||= entry.status === 'error';
    }
    if (failed) return { status: 'error', href: current.url };
    if (unresolved) return { status: 'pending', href: current.url };
    if (window.GPOConfigs?.appEmbed && !state.gpoCompleted) return { status: 'pending', href: current.url };
    return { status: 'ready' };
  }
  function focusConfiguration(event, result) {
    if (result.id && result.id !== current.id) return;
    event.preventDefault();
    const root = productRoot();
    const target = root?.querySelector('.gpo-app') || root?.querySelector('variant-selects') || root;
    if (!target) return;
    target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const field = Array.from(target.querySelectorAll('input:not([disabled]):not([type="hidden"]),select:not([disabled]),button:not([disabled])')).find((item) => item.getClientRects().length && getComputedStyle(item).visibility !== 'hidden');
    if (field) field.focus({ preventScroll: true });
    else { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
  }
  function refresh() {
    const root = bundleRoot();
    if (!root) return;
    const result = assess(root);
    state.status = result.status;
    root.dataset.jdmBundleState = result.status;
    const blocked = result.status !== 'ready';
    root.querySelectorAll('.cbb-frequently-bought-add-button').forEach((button) => {
      if (blocked) {
        if (!buttonStates.has(button)) buttonStates.set(button, { inert: button.inert, aria: button.getAttribute('aria-disabled'), tab: button.getAttribute('tabindex') });
        if (!button.inert) button.inert = true;
        if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
        if (button.getAttribute('tabindex') !== '-1') button.setAttribute('tabindex', '-1');
      } else if (buttonStates.has(button)) {
        const saved = buttonStates.get(button);
        button.inert = saved.inert;
        for (const [name, value] of [['aria-disabled', saved.aria], ['tabindex', saved.tab]]) {
          if (value === null) button.removeAttribute(name); else button.setAttribute(name, value);
        }
        buttonStates.delete(button);
      }
    });
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'jdm-bundle-safety-message';
      const text = document.createElement('p');
      text.setAttribute('role', 'status');
      const link = document.createElement('a');
      link.textContent = labels.configure;
      link.addEventListener('click', (event) => focusConfiguration(event, assess(bundleRoot())));
      notice.append(text, link);
    }
    notice.hidden = !blocked;
    if (blocked) {
      const text = notice.querySelector('p');
      if (text.textContent !== labels[result.status]) text.textContent = labels[result.status];
      notice.querySelector('a').href = result.href || current.url;
      if (!root.contains(notice)) {
        const form = root.querySelector('.cbb-frequently-bought-form');
        if (form) form.insertAdjacentElement('beforebegin', notice); else root.appendChild(notice);
      }
    }
  }
  function intercept(event) {
    const root = bundleRoot();
    if (!root || !event.target?.closest || !root.contains(event.target)) return;
    const purchase = event.type === 'submit' || event.target.closest('.cbb-frequently-bought-add-button');
    if (!purchase || assess(root).status === 'ready') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    refresh();
    notice?.querySelector('a')?.focus();
  }
  state.intercept = intercept;
  if (!window.jdmPurchaseBootstrap) {
    window.addEventListener('click', intercept, true);
    window.addEventListener('submit', intercept, true);
  }
  function bind() {
    if (!document.body || state.observing) return;
    state.observing = true;
    new MutationObserver((records) => {
      if (records.some((record) => !record.target.closest?.('.jdm-bundle-safety-message') && (
        record.target.closest?.('#frequently-bought-together-app-block,.gpo-app') ||
        Array.from(record.addedNodes || []).some((node) => node.nodeType === 1 && (node.matches?.('#frequently-bought-together-app-block,.gpo-app') || node.querySelector?.('#frequently-bought-together-app-block,.gpo-app')))
      ))) schedule();
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['href', 'name', 'presence'] });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true }); else bind();
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('product-info:loaded', schedule);
})();
